import React from 'react';
import '../css/CustomAlert.css';

const CustomAlert = ({ title, message, type, onClose, buttons = [] }) => {

  // Function to handle button click: Execute action and close the alert
    const handleButtonClick = (onClick) => {
        if (onClick) {
        onClick(); // Execute the custom onClick action if provided
        }
        onClose(); // Always close the alert after clicking
    };

    const alertType = type || 'success'; // Default to 'success' if no type is provided

    return (
        <div className="alert-overlay">
        <div className="alert-container">
            <div className={`alert alert-${alertType}`}>
            {title && (
                <div className="alert-title">
                    {title}
                </div>
            )}
            <div className="alert-message">
                {message}
            </div>
            <div className={`alert-buttons ${(buttons.length === 1 || buttons.length === 0) ? 'single-button' : ''}`}>
                {buttons.length > 0 ? (
                buttons.map((button, index) => (
                    <button
                    key={index}
                    onClick={() => handleButtonClick(button.onClick)}
                    className={`btn-${button.type || 'secondary'}`} // Default to 'secondary' if no type is provided
                    >
                    {button.label}
                    </button>
                ))
                ) : (
                <button onClick={onClose} className="btn-secondary">
                    OK
                </button>
                )}
            </div>
            </div>
        </div>
        </div>
    );
};

export default CustomAlert;
